import { PageOptions } from "@/features/dashboard/DashboardStateContext";

export const tabToPageOption: Record<string, PageOptions> = {
  schedules: "Schedules",
  liveMap: "LiveMap",
  visitors: "Visitors",
  news: "News",
  siteInfo: "SiteInfo"
};

export const pageOptionToTab: Record<PageOptions, string> = {
  Schedules: "schedules",
  LiveMap: "liveMap",
  Visitors: "visitors",
  News: "news",
  SiteInfo: "siteInfo"
};

export const DEFAULT_DAYS_COUNT = 5;
